import React, { FCC } from 'react'

import { useThemeContext } from '@sketch/global-styles'
import { WorkspaceApprovedModal } from '../WorkspaceApprovedModal'

import { ModalInjectedProps } from '@sketch/components'

// Assets
import Sticker from '@sketch/icons/sticker-animation-light@1x.webp'
import StickerDark from '@sketch/icons/sticker-animation-dark@1x.webp'
import Sticker2x from '@sketch/icons/sticker-animation-light@2x.webp'
import StickerDark2x from '@sketch/icons/sticker-animation-dark@2x.webp'
import { useHistory, useRouteMatch } from 'react-router'
import { routes } from '@sketch/modules-common'

interface SubscriptionDoneModalProps extends ModalInjectedProps {
  onHide: () => void
}

const SubscriptionDoneModal: FCC<SubscriptionDoneModalProps> = ({ onHide }) => {
  const { theme } = useThemeContext()
  const history = useHistory()
  const isRenewingTrial = useRouteMatch({
    path: routes.WORKSPACE_TRIAL_THANK_YOU.template(),
  })

  const handleAction = () => {
    if (isRenewingTrial) {
      history.push(routes.WORKSPACE_AGNOSTIC_SETTINGS_BILLING.create({}))
    }
  }

  return (
    <WorkspaceApprovedModal
      title="All Done!"
      buttonText="Go to Workspace"
      description={
        <>
          You can now start using Sketch.
          <br />
          Thanks for subscribing!
        </>
      }
      image={
        theme === 'light'
          ? { src: Sticker, src2x: Sticker2x }
          : { src: StickerDark, src2x: StickerDark2x }
      }
      hideModal={onHide}
      action={handleAction}
    />
  )
}

export default SubscriptionDoneModal
